/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DashboardPageBlockCartesianSerieGrouping'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DashboardPageBlockCartesianSerieGrouping'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockCartesianSerieGroupingApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DashboardPageBlockCartesianSerieGrouping);
  }
}(this, function(ApiClient, DashboardPageBlockCartesianSerieGrouping) {
  'use strict';

  /**
   * DashboardPageBlockCartesianSerieGrouping service.
   * @module api/DashboardPageBlockCartesianSerieGroupingApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DashboardPageBlockCartesianSerieGroupingApi. 
   * @alias module:api/DashboardPageBlockCartesianSerieGroupingApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieGroupingAddPut operation.
     * @callback module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlockCartesianSerieGrouping} body 
     * @param {module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageBlockCartesianSerieGroupingAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieGroupingAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockCartesianSerieGroupingAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieGrouping/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieGroupingDeleteGet operation.
     * @callback module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} groupingID 
     * @param {module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageBlockCartesianSerieGroupingDeleteGet = function(_4SAPIAppID, groupingID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieGroupingDeleteGet";
      }

      // verify the required parameter 'groupingID' is set
      if (groupingID == undefined || groupingID == null) {
        throw "Missing the required parameter 'groupingID' when calling dashboardPageBlockCartesianSerieGroupingDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'groupingID': groupingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieGrouping/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieGroupingEditPut operation.
     * @callback module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlockCartesianSerieGrouping} body 
     * @param {module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageBlockCartesianSerieGroupingEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieGroupingEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockCartesianSerieGroupingEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieGrouping/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieGroupingSearchPut operation.
     * @callback module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/DashboardPageBlockCartesianSerieGrouping>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlockCartesianSerieGrouping} body 
     * @param {module:api/DashboardPageBlockCartesianSerieGroupingApi~dashboardPageBlockCartesianSerieGroupingSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/DashboardPageBlockCartesianSerieGrouping>}
     */
    this.dashboardPageBlockCartesianSerieGroupingSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieGroupingSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockCartesianSerieGroupingSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [DashboardPageBlockCartesianSerieGrouping];

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieGrouping/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
